import { render, staticRenderFns } from "./DashboardContent.vue?vue&type=template&id=30b7a536&scoped=true"
import script from "./DashboardContent.vue?vue&type=script&lang=js"
export * from "./DashboardContent.vue?vue&type=script&lang=js"
import style0 from "./DashboardContent.vue?vue&type=style&index=0&id=30b7a536&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b7a536",
  null
  
)

export default component.exports